import { render, staticRenderFns } from "./analytics-table.vue?vue&type=template&id=f522abbe&"
import script from "./analytics-table.ts?vue&type=script&lang=ts&"
export * from "./analytics-table.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports